/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSendSoft = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-send-soft',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.506 3.234c-1.962-.906-4.057.97-3.374 3.02l1.914 5.741a.822.822 0 0 1 0 .52l-1.914 5.741c-.683 2.05 1.412 3.926 3.374 3.02l16.31-7.528c1.275-.588 1.275-2.398 0-2.986L5.507 3.234Zm-1.814 2.5a.822.822 0 0 1 1.125-1.007l16.31 7.528-16.31 7.528a.822.822 0 0 1-1.125-1.007l1.9-5.699h9.275a.822.822 0 1 0 0-1.644H5.592l-1.9-5.7Z" })));
});
IconSendSoft.displayName = 'IconSendSoft';
export default IconSendSoft;
